import { Gamepad2, Coffee, Joystick, Heart } from "lucide-react";

const items = [
  { icon: Gamepad2, label: "100% Accessible Space" },
  { icon: Coffee, label: "Specialty Single Origin" },
  { icon: Joystick, label: "Vintage Consoles" },
  { icon: Heart, label: "Proud Inclusive Team" },
];

const Row = () => (
  <>
    {items.map(({ icon: Icon, label }) => (
      <span key={label} className="flex items-center gap-3">
        <Icon className="w-4 h-4 text-[#FF2E88]" strokeWidth={2.2} />
        {label}
        <span className="text-[#FF2E88]">✦</span>
      </span>
    ))}
  </>
);

export const Marquee = () => (
  <div
    data-testid="values-marquee"
    className="border-y border-[#3B2760] bg-[#26153F] py-4 overflow-hidden"
  >
    <div className="mq-track gap-12 font-bold mono-lbl text-xs uppercase tracking-widest text-[#A08FB8]">
      <Row />
      <Row />
    </div>
  </div>
);
